import {
    Configuration,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser';
import { getConfig, GlobalConfigProperties } from './ABHub/ABHubGlobalConfig';

let msalInstance: PublicClientApplication | null = null;

export function getMsalConfig(): Configuration {
    return {
        auth: {
            clientId: getConfig(GlobalConfigProperties.AadClient),
            authority:
                getConfig(GlobalConfigProperties.AadUrl) +
                getConfig(GlobalConfigProperties.AadTenant),
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
        },
        cache: {
            cacheLocation: 'sessionStorage',
        },
        system: {
            loggerOptions: {
                logLevel: LogLevel.Warning,
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) return;
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            break;
                        case LogLevel.Warning:
                            console.warn(message);
                            break;
                    }
                },
            },
        },
    };
}

export async function initializeMsal(): Promise<PublicClientApplication> {
    if (!msalInstance) {
        msalInstance = new PublicClientApplication(getMsalConfig());
        await msalInstance.initialize();
    }
    return msalInstance;
}

export function getMsalInstance(): PublicClientApplication {
    if (!msalInstance) {
        throw new Error(
            'MSAL instance not initialized. Call initializeMsal() first.'
        );
    }
    return msalInstance;
}

export const agpLoginRequest = {
    scopes: ['openid', 'profile', 'offline_access'],
};
